export const translations = {
  en: {
    // Navigation
    home: "Home",
    about: "About",
    training: "Legal AI Training",
    management: "AI for Executives",
    audit: "AI Audit",
    blog: "Blog",
    contact: "Contact",
    login: "Login",
    register: "Register",
    dashboard: "Dashboard",
    logout: "Logout",
    
    // Language switching
    switchToFrench: "Français",
    switchToEnglish: "English",
    
    // Hero section
    heroTagline: "Legal AI Excellence",
    heroTitle: "Master Legal AI",
    heroTitleHighlight: "with our Certified AI Training",
    heroSubtitle: "Expert training and strategic consulting for law firms embracing artificial intelligence. We guide legal professionals through the AI revolution with tools and practices tailored to their needs.",
    heroCtaTraining: "Explore Legal AI Training",
    heroCtaAudit: "Request an AI Audit",
    heroTrust: "Trusted by leading law firms across Europe",
    heroBubble: "Welcome! Discover AI training designed by and for lawyers and legal professionals 🎓",
    heroCtaCatalog: "Choose my Legal AI Training Session",
    
    // Services section
    servicesTitle: "Our Services",
    servicesSubtitle: "Comprehensive AI solutions tailored for the legal profession",
    serviceTrainingTitle: "AI Training & Certification",
    serviceTrainingDesc: "Hands-on training on legal AI tools and practices tailored to your needs. From fundamentals to advanced prompt engineering for legal professionals.",
    serviceAuditTitle: "AI Strategy Audit",
    serviceAuditDesc: "In-depth assessment of your firm's AI policies, tool adoption, and implementation strategy. Covering France and Common Law jurisdictions.",
    serviceConsultingTitle: "Implementation Consulting",
    serviceConsultingDesc: "End-to-end guidance on integrating AI tools into your legal workflows with compliance and ethics at the core.",
    
    // Training tools
    toolsTitle: "The training that modernizes legal professions",
    toolsSubtitle: "Master the leading AI platforms transforming legal practice",
    
    // About section
    aboutTitle: "About Gaius Legal AI Training",
    aboutSubtitle: "Leader in Legal AI Training",
    aboutTeam: "Gaius brings together lawyers and tech specialists to help legal professionals harness AI with confidence. We combine deep legal expertise with hands-on technology experience.",
    aboutMission: "Our mission: empower lawyers and counsel to leverage generative AI responsibly and effectively.",
    aboutVision: "We envision a legal profession where AI augments human expertise, enabling lawyers to deliver better outcomes for their clients.",
    aboutWhyGaiusTitle: "Why Gaius for AI Training?",
    aboutWhyGaius: "Named after the visionary 2nd-century Roman jurist whose Institutes structured fragmented law into a coherent, teachable framework — laying the foundations of the Corpus Juris Civilis. Like him, we aim to make the complex accessible: structuring AI adoption in legal practice to be rigorous, practical, and transformative.",
    
    // Values
    valueExcellenceTitle: "Excellence",
    valueExcellenceDesc: "Rigorous, precise, and documented training based on real-world legal practice",
    valueEthicsTitle: "Ethics",
    valueEthicsDesc: "Responsible AI adoption with a focus on compliance, confidentiality, and professional standards",
    valueInnovationTitle: "Innovation",
    valueInnovationDesc: "Staying ahead of the curve with the latest AI tools and techniques for legal work",
    
    // Training page
    trainingPageTitle: "AI Training Programs",
    trainingPageSubtitle: "Flexible training designed for busy legal professionals — short modules that fit your schedule",
    trainingIntroTitle: "Legal AI Essentials",
    trainingIntroDesc: "A practical introduction to AI tools for legal work. Short, focused modules you can complete between client meetings.",
    trainingIntroPrice: "Ideal for getting started",
    trainingIntroDuration: "3 × 1.5h modules",
    trainingAdvancedTitle: "Advanced Prompt Engineering",
    trainingAdvancedDesc: "Master the art of crafting effective prompts for legal research, drafting, and analysis. Hands-on workshops with real cases.",
    trainingAdvancedPrice: "Most popular",
    trainingAdvancedDuration: "4 × 2h modules",
    trainingAdvancedBadge: "Recommended",
    trainingCustomTitle: "Firm-Wide Training",
    trainingCustomDesc: "Tailored programs for your firm's practice areas and objectives. Flexible scheduling — we adapt to your team's availability.",
    trainingCustomPrice: "Best for teams",
    trainingCustomDuration: "Flexible modules",
    trainingCertification: "Certificate of Completion",
    trainingMaterials: "Course Materials Included",
    trainingSupport: "30-Day Post-Training Support",
    bookTraining: "Request Information",
    
    // Audit page
    auditPageTitle: "AI Strategy Audit",
    auditPageSubtitle: "Comprehensive assessment of your firm's AI readiness and implementation",
    auditWhatTitle: "What We Audit",
    auditPolicyTitle: "AI Policy Review",
    auditPolicyDesc: "Assessment of existing AI governance policies, usage guidelines, and compliance frameworks",
    auditToolsTitle: "Tool Assessment",
    auditToolsDesc: "Evaluation of current AI tool adoption, licensing, and integration effectiveness",
    auditWorkflowTitle: "Workflow Analysis",
    auditWorkflowDesc: "Review of how AI is being used across practice areas and identification of optimization opportunities",
    auditRiskTitle: "Risk Assessment",
    auditRiskDesc: "Identification of potential risks including data privacy, confidentiality, and regulatory compliance",
    auditDeliverables: "Audit Deliverables",
    auditReport: "Comprehensive written report with findings and recommendations",
    auditRoadmap: "Strategic roadmap for AI implementation or improvement",
    auditBenchmark: "Benchmarking against industry best practices",
    auditPresentation: "Executive presentation for firm leadership",
    requestAudit: "Request an Audit",
    
    // Blog
    blogTitle: "Legal AI Insights",
    blogSubtitle: "Expert analysis on AI developments shaping the legal profession",
    readMore: "Read More",
    publishedOn: "Published on",
    byAuthor: "by",
    
    // Contact
    contactTitle: "Get in Touch",
    contactSubtitle: "Ready to transform your legal practice with AI? Let's discuss how we can help.",
    contactName: "Full Name",
    contactEmail: "Email Address",
    contactCompany: "Law Firm / Organization",
    contactSubject: "Subject",
    contactMessage: "Your Message",
    contactSend: "Send Message",
    contactSuccess: "Message sent successfully. We'll be in touch soon.",
    contactError: "An error occurred. Please try again.",
    contactInfo: "Contact Information",
    contactLocation: "Paris, France",
    contactAvailability: "Available for engagements across Europe and internationally",
    
    // Legal pages
    legalNoticeTitle: "Legal Notice",
    privacyPolicyTitle: "Privacy Policy",
    termsTitle: "Terms of Service",
    cookieNotice: "We use cookies to enhance your experience. By continuing, you agree to our",
    cookiePolicy: "cookie policy",
    acceptCookies: "Accept",
    declineCookies: "Decline",
    
    // Auth
    loginTitle: "Access your Gaius account",
    loginSubtitle: "Sign in to access your training dashboard",
    registerTitle: "Create Account",
    registerSubtitle: "Join the community of AI-enabled legal professionals",
    emailLabel: "Email",
    passwordLabel: "Password",
    confirmPasswordLabel: "Confirm Password",
    forgotPassword: "Forgot password?",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    signInGoogle: "Continue with Google",
    signInLinkedIn: "Continue with LinkedIn",
    orContinueWith: "or continue with",
    
    // Dashboard
    dashboardTitle: "My Dashboard",
    dashboardWelcome: "Welcome back",
    myTrainingPlan: "My Training Plan",
    myProgress: "My Progress",
    myMaterials: "Course Materials",
    myHistory: "Training History",
    accountSettings: "Account Settings",
    noTrainings: "You haven't enrolled in any training yet.",
    browseTrainings: "Browse Training Programs",
    deleteAccount: "Delete Account",
    deleteAccountWarning: "This action is irreversible. All your data will be permanently deleted.",
    deleteAccountConfirm: "Are you sure you want to delete your account?",
    deleteAccountButton: "Delete my account",
    cancel: "Cancel",
    accountDeleted: "Your account has been successfully deleted.",
    deleteAccountError: "An error occurred while deleting your account.",
    
    // Footer
    footerTagline: "Empowering legal professionals with AI expertise",
    footerQuickLinks: "Quick Links",
    footerLegal: "Legal",
    footerConnect: "Connect",
    allRightsReserved: "All rights reserved",
    
    // Common
    learnMore: "Learn More",
    getStarted: "Get Started",
    viewAll: "View All",
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    
    // 404
    notFoundTitle: "Page Not Found",
    notFoundDesc: "The page you're looking for doesn't exist or has been moved.",
    returnHome: "Return to Home",
  },
  fr: {
    // Navigation
    home: "Accueil",
    about: "À propos",
    training: "Formations IA juridique",
    management: "IA pour les Dirigeants",
    audit: "Audit IA",
    blog: "Actualités",
    contact: "Contact",
    login: "Connexion",
    register: "Inscription",
    dashboard: "Tableau de bord",
    logout: "Déconnexion",
    
    // Language switching
    switchToFrench: "Français",
    switchToEnglish: "English",
    
    // Hero section
    heroTagline: "Excellence en IA Juridique",
    heroTitle: "Maîtrisez l'IA juridique",
    heroTitleHighlight: "avec nos formations IA certifiantes",
    heroSubtitle: "Formation experte en IA pour les cabinets d'avocats qui adoptent ces nouvelles méthodes de travail. Face au grand nombre d'outils existants, nous guidons les professionnels du droit dans la révolution de l'IA.",
    heroCtaTraining: "Accéder aux formations IA juridique",
    heroCtaAudit: "Demander un Audit IA",
    heroTrust: "La confiance des cabinets leaders en Europe",
    heroBubble: "Bienvenue ! Découvrez une formation IA pensée par et pour les avocats et juristes 🎓",
    heroCtaCatalog: "Choisir ma Formation IA juridique",
    
    // Services section
    servicesTitle: "Nos Services",
    servicesSubtitle: "Solutions IA complètes adaptées à la profession juridique",
    serviceTrainingTitle: "Formation & Certification IA",
    serviceTrainingDesc: "Formation pratique sur les outils et pratiques d'IA juridique adaptés à vos besoins. Des fondamentaux au prompt engineering avancé pour les professionnels du droit.",
    serviceAuditTitle: "Audit Stratégie IA",
    serviceAuditDesc: "Évaluation approfondie des politiques IA de votre cabinet, de l'adoption des outils et de la stratégie de mise en œuvre. France et juridictions de Common Law.",
    serviceConsultingTitle: "Conseil en Implémentation",
    serviceConsultingDesc: "Accompagnement de bout en bout pour intégrer les outils IA dans vos workflows juridiques, avec conformité et éthique au cœur.",
    
    // Training tools
    toolsTitle: "La formation qui modernise les professions du droit",
    toolsSubtitle: "Maîtrisez les plateformes IA leaders qui transforment la pratique juridique",
    
    // About section
    aboutTitle: "À propos de Gaius Formation IA",
    aboutSubtitle: "Leader de la formation en IA juridique",
    aboutTeam: "Gaius réunit avocats et spécialistes tech pour accompagner les professionnels du droit dans leur maîtrise de l'IA. Nous combinons expertise juridique approfondie et expérience technologique concrète.",
    aboutMission: "Notre mission : donner aux avocats et juristes les clés pour exploiter l'IA générative de manière responsable et efficace.",
    aboutVision: "Nous imaginons une profession juridique où l'IA augmente l'expertise humaine, permettant aux avocats de délivrer de meilleurs résultats pour leurs clients.",
    aboutWhyGaiusTitle: "Pourquoi Gaius pour une formation en IA ?",
    aboutWhyGaius: "Du nom du juriste romain visionnaire du IIe siècle, dont les Institutes ont structuré un droit fragmenté en un cadre cohérent et enseignable — posant les fondations du Corpus Juris Civilis. Comme lui, nous voulons rendre le complexe accessible : structurer l'adoption de l'IA juridique pour qu'elle soit rigoureuse, pratique et transformatrice.",
    
    // Values
    valueExcellenceTitle: "Excellence",
    valueExcellenceDesc: "Formation rigoureuse, précise et documentée basée sur la pratique juridique réelle",
    valueEthicsTitle: "Éthique",
    valueEthicsDesc: "Adoption responsable de l'IA avec un focus sur la conformité, la confidentialité et les standards professionnels",
    valueInnovationTitle: "Innovation",
    valueInnovationDesc: "Toujours à la pointe des derniers outils et techniques IA pour le travail juridique",
    
    // Training page
    trainingPageTitle: "Programmes de Formation IA",
    trainingPageSubtitle: "Formations flexibles conçues pour les avocats débordés — modules courts qui s'adaptent à votre emploi du temps",
    trainingIntroTitle: "Fondamentaux de l'IA Juridique",
    trainingIntroDesc: "Une introduction pratique aux outils IA pour le travail juridique. Modules courts et ciblés, réalisables entre deux rendez-vous clients.",
    trainingIntroPrice: "Idéal pour débuter",
    trainingIntroDuration: "3 × 1h30 de modules",
    trainingAdvancedTitle: "Prompt Engineering Avancé",
    trainingAdvancedDesc: "Maîtrisez l'art de créer des prompts efficaces pour la recherche juridique, la rédaction et l'analyse. Ateliers pratiques avec des cas réels.",
    trainingAdvancedPrice: "Le plus populaire",
    trainingAdvancedDuration: "4 × 2h de modules",
    trainingAdvancedBadge: "Recommandé",
    trainingCustomTitle: "Formation Cabinet",
    trainingCustomDesc: "Programmes sur-mesure pour les domaines de pratique de votre cabinet. Planning flexible — nous nous adaptons aux disponibilités de votre équipe.",
    trainingCustomPrice: "Idéal pour les équipes",
    trainingCustomDuration: "Modules flexibles",
    trainingCertification: "Certificat de Réussite",
    trainingMaterials: "Supports de Cours Inclus",
    trainingSupport: "Accompagnement 30 Jours Post-Formation",
    bookTraining: "Demander des Informations",
    
    // Audit page
    auditPageTitle: "Audit Stratégie IA",
    auditPageSubtitle: "Évaluation complète de la maturité IA et de la mise en œuvre de votre cabinet",
    auditWhatTitle: "Ce Que Nous Auditons",
    auditPolicyTitle: "Revue des Politiques IA",
    auditPolicyDesc: "Évaluation des politiques de gouvernance IA existantes, des directives d'utilisation et des cadres de conformité",
    auditToolsTitle: "Évaluation des Outils",
    auditToolsDesc: "Évaluation de l'adoption actuelle des outils IA, des licences et de l'efficacité de l'intégration",
    auditWorkflowTitle: "Analyse des Workflows",
    auditWorkflowDesc: "Revue de l'utilisation de l'IA dans les domaines de pratique et identification des opportunités d'optimisation",
    auditRiskTitle: "Évaluation des Risques",
    auditRiskDesc: "Identification des risques potentiels incluant la confidentialité des données, le secret professionnel et la conformité réglementaire",
    auditDeliverables: "Livrables de l'Audit",
    auditReport: "Rapport écrit complet avec conclusions et recommandations",
    auditRoadmap: "Feuille de route stratégique pour la mise en œuvre ou l'amélioration de l'IA",
    auditBenchmark: "Benchmark par rapport aux meilleures pratiques du secteur",
    auditPresentation: "Présentation exécutive pour la direction du cabinet",
    requestAudit: "Demander un Audit",
    
    // Blog
    blogTitle: "Actualités IA Juridique",
    blogSubtitle: "Analyse experte des évolutions IA qui façonnent la profession juridique",
    readMore: "Lire la Suite",
    publishedOn: "Publié le",
    byAuthor: "par",
    
    // Contact
    contactTitle: "Contactez-nous",
    contactSubtitle: "Prêt à transformer votre pratique juridique avec l'IA ? Discutons de comment nous pouvons vous aider.",
    contactName: "Nom Complet",
    contactEmail: "Adresse Email",
    contactCompany: "Cabinet / Organisation",
    contactSubject: "Objet",
    contactMessage: "Votre Message",
    contactSend: "Envoyer le Message",
    contactSuccess: "Message envoyé avec succès. Nous vous recontacterons rapidement.",
    contactError: "Une erreur est survenue. Veuillez réessayer.",
    contactInfo: "Coordonnées",
    contactLocation: "Paris, France",
    contactAvailability: "Disponible pour des missions en Europe et à l'international",
    
    // Legal pages
    legalNoticeTitle: "Mentions Légales",
    privacyPolicyTitle: "Politique de Confidentialité",
    termsTitle: "Conditions Générales d'Utilisation",
    cookieNotice: "Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre",
    cookiePolicy: "politique cookies",
    acceptCookies: "Accepter",
    declineCookies: "Refuser",
    
    // Auth
    loginTitle: "Vous connecter à votre espace Gaius",
    loginSubtitle: "Connectez-vous pour accéder à votre espace formation",
    registerTitle: "Créer un Compte",
    registerSubtitle: "Rejoignez la communauté des professionnels du droit augmentés par l'IA",
    emailLabel: "Email",
    passwordLabel: "Mot de passe",
    confirmPasswordLabel: "Confirmer le mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    signInGoogle: "Continuer avec Google",
    signInLinkedIn: "Continuer avec LinkedIn",
    orContinueWith: "ou continuer avec",
    
    // Dashboard
    dashboardTitle: "Mon Tableau de Bord",
    dashboardWelcome: "Bienvenue",
    myTrainingPlan: "Mon Plan de Formation",
    myProgress: "Ma Progression",
    myMaterials: "Supports de Cours",
    myHistory: "Historique de Formation",
    accountSettings: "Paramètres du Compte",
    noTrainings: "Vous n'êtes inscrit à aucune formation pour le moment.",
    browseTrainings: "Parcourir les Formations",
    deleteAccount: "Supprimer le compte",
    deleteAccountWarning: "Cette action est irréversible. Toutes vos données seront définitivement supprimées.",
    deleteAccountConfirm: "Êtes-vous sûr de vouloir supprimer votre compte ?",
    deleteAccountButton: "Supprimer mon compte",
    cancel: "Annuler",
    accountDeleted: "Votre compte a été supprimé avec succès.",
    deleteAccountError: "Une erreur est survenue lors de la suppression de votre compte.",
    
    // Footer
    footerTagline: "Accompagner les professionnels du droit vers l'excellence IA",
    footerQuickLinks: "Liens Rapides",
    footerLegal: "Mentions Légales",
    footerConnect: "Nous Suivre",
    allRightsReserved: "Tous droits réservés",
    
    // Common
    learnMore: "En Savoir Plus",
    getStarted: "Commencer",
    viewAll: "Voir Tout",
    loading: "Chargement...",
    error: "Une erreur est survenue",
    success: "Succès",
    
    // 404
    notFoundTitle: "Page Introuvable",
    notFoundDesc: "La page que vous recherchez n'existe pas ou a été déplacée.",
    returnHome: "Retour à l'Accueil",
  }
};

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.en;

export const getTranslation = (lang: Language, key: TranslationKey): string => {
  return translations[lang][key] || translations.en[key] || key;
};
